import { Component, EventEmitter, inject, Input, Output } from '@angular/core';

// Services
import { CommonService } from '../../../core/services/common/common.service';
import { NetworkService } from '../../../core/services/network/network.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['../../../../styles/page.preset.scss'],
  standalone: false,
})
export class HeaderComponent {
  @Input() TITLE: string;
  @Input() BACKBUTTON: boolean = true;
  @Input() TOHIDE: boolean = false;

  @Input() SEARCHBARPRESENT: boolean = false;
  @Input() SEARCHBARVALUE?: string;

  @Output() searchBarValueChanged = new EventEmitter<string>();

  private readonly common = inject(CommonService);
  private readonly network = inject(NetworkService);

  get isBlockedApp(): boolean {
    return this.network.blockedApp;
  }

  get internetAvailable(): boolean {
    return this.network.connected;
  }

  get shouldShowBackButton(): boolean {
    return this.BACKBUTTON && this.common.PLATFORM !== 'android';
  }

  emitNewValue(): void {
    this.searchBarValueChanged.emit(this.SEARCHBARVALUE);
  }
}
